module.exports = __webpack_public_path__ + "img/350.997a5165.gif";